export default "__VITE_ASSET__ChuHpToa__"